<template>
  <v-toolbar dense flat outlined color="lightgrey" class="pl-1 pr-1">
    <v-row dense>
      <v-col class="d-flex align-center">
        <v-chip v-if="cooperative" color="primary" class="mr-1">
          Coopérative
        </v-chip>

        <div class="d-flex align-center">
          <a-issue-teleservice-icon v-if="issueTeleservice" />
          <span class="d-none d-lg-inline">Numéro :&nbsp;</span>
          <span class="secondary--text">{{ numero }}</span>
        </div>

        <template v-if="association">
          <v-divider class="mr-2 ml-2 d-md-block" vertical />
          <div class="d-flex align-center">
            <span class="d-none d-lg-inline">Association :&nbsp;</span>
            <router-link v-if="association" :to="toDetailAssociation(association)">{{
              association
            }}</router-link>
          </div>
        </template>

        <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
        <div class="d-none d-md-inline">
          <span class="d-none d-lg-inline">Dénomination :&nbsp;</span>
          <span class="secondary--text">{{ denomination }}</span>
        </div>

        <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
        <div class="d-none d-md-inline">
          <span class="d-none d-lg-inline">Type :&nbsp;</span>
          <span class="secondary--text">{{ type | typerequete }}</span>
        </div>

        <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
        <div class="d-none d-md-inline">
          <span class="d-none d-lg-inline">Juridiction :&nbsp;</span>
          <span class="secondary--text">{{ juridiction }}</span>
        </div>
      </v-col>
      <v-col cols="auto" class="d-flex align-center">
          <a-association-etat-chip etat="RECTIFIEE_OFFICE" v-if="rectifieeOffice" class="mr-1"/>
          <a-requete-etat-chip :etat="etat" />
      </v-col>
    </v-row>
  </v-toolbar>
</template>

<script>
import { toDetailAssociation } from "@/routes/associations";
export default {
  props: {
    value: {
      type: Object,
      required: false,
    },
    etat: {
      type: String,
      required: false,
    },
    association: {
      type: String,
      required: false,
    },
    radieeOffice: {
      type: Boolean,
      default: false,
    },
    rectifieeOffice: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    numero() {
      return this.value?.numero;
    },
    type() {
      return this.value?.type;
    },
    denomination() {
      return this.value?.denomination;
    },
    issueTeleservice() {
      return !!this.value?.issueTeleservice;
    },
    cooperative() {
      return !!this.value?.cooperative;
    },
    adresse() {
      if (this.value) {
        const { adresse, commune, codePostal, complementAdresse } = this.value;
        return `${adresse} ${complementAdresse} ${codePostal} ${commune}`;
      }
      return null;
    },
    juridiction() {
      return this.value?.tribunal;
    },
  },
  methods: {
    toDetailAssociation,
  },
};
</script>
